import request from '@/utils/request'

/**
 * 获取组织管理员列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgAdminList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/admin/list',
    method: 'post',
    data
  })
}
/**
 * 根据经营类型ID，获取组织经营列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgBusinessList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/business/list',
    method: 'post',
    data
  })
}
/**
 * 获取部门下的人员列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgDeptMemberList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/dept/member/list',
    method: 'post',
    data
  })
}
/**
 * 获取组织详情(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgDetailGet(data) {
  return request({
    type: 'base',
    url: 'oauth/org/detail/get',
    method: 'post',
    data
  })
}
/**
 * 获取组织详情(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgDetailInnerGet(data) {
  return request({
    type: 'base',
    url: 'oauth/org/detail/inner/get',
    method: 'post',
    data
  })
}
/**
 * 获取组织列表(oauth)(内部调用)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgDetailInnerList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/detail/inner/list',
    method: 'post',
    data
  })
}
/**
 * 获取组织列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgDetailList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/detail/list',
    method: 'post',
    data
  })
}
/**
 * 获取组织列表(oauth不需要登录)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgDetailNewList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/detail/new/list',
    method: 'post',
    data
  })
}
/**
 * 根据组织，根据部门编号获取今年离职员工列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgMemberDelList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/member/del/list',
    method: 'post',
    data
  })
}
/**
 * 获取人员详情(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgMemberDetailGet(data) {
  return request({
    type: 'base',
    url: 'oauth/org/member/detail/get',
    method: 'post',
    data
  })
}
/**
 * 根据用户ID获取用户信息(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgMemberInfo(data) {
  return request({
    type: 'base',
    url: 'oauth/org/member/info',
    method: 'post',
    data
  })
}
/**
 * 获取所有的组织人员列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgMemberList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/member/list',
    method: 'post',
    data
  })
}
/**
 * 获取人员所在的组织列表(notoken)(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgMemberNotokenList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/member/notoken/list',
    method: 'post',
    data
  })
}
/**
 * 获取人员所在的组织列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgMemberOrgList(data) {
  return request({
    type: 'base',
    url: 'oauth/org/member/org/list',
    method: 'post',
    data
  })
}
/**
 * 获取人员基本信息(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrgMemberSysidInfo(data) {
  return request({
    type: 'base',
    url: 'oauth/org/member/sysid/info',
    method: 'post',
    data
  })
}
/**
 * 根据组织列表，获取人员信息列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthOrglistMemberList(data) {
  return request({
    type: 'base',
    url: 'oauth/orglist/member/list',
    method: 'post',
    data
  })
}
/**
 * 新增组织信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationAdd(data) {
  return request({
    type: 'base',
    url: 'organization/add',
    method: 'post',
    data
  })
}
/**
 * 删除组织
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationDelete(data) {
  return request({
    type: 'base',
    url: 'organization/delete',
    method: 'post',
    data
  })
}
/**
 * 根据组织编号获取组织信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationDetailGet(data) {
  return request({
    type: 'base',
    url: 'organization/detail/get',
    method: 'post',
    data
  })
}
/**
 * 添加组织成员
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberAdd(data) {
  return request({
    type: 'base',
    url: 'organization/member/add',
    method: 'post',
    data
  })
}
/**
 * 根据部门编号获取组织成员
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberDeptList(data) {
  return request({
    type: 'base',
    url: 'organization/member/dept/list',
    method: 'post',
    data
  })
}
/**
 * 获取组织成员详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberDetailGet(data) {
  return request({
    type: 'base',
    url: 'organization/member/detail/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织编号获取所有组织成员
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberOrgAllList(data) {
  return request({
    type: 'base',
    url: 'organization/member/org/all/list',
    method: 'post',
    data
  })
}
/**
 * 根据组织编号获取组织成员
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberOrgList(data) {
  return request({
    type: 'base',
    url: 'organization/member/org/list',
    method: 'post',
    data
  })
}
/**
 * 将组织成员从组织中移除
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberRemove(data) {
  return request({
    type: 'base',
    url: 'organization/member/remove',
    method: 'post',
    data
  })
}
/**
 * 从系统用户中选择添加组织成员
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberSelectAdd(data) {
  return request({
    type: 'base',
    url: 'organization/member/select/add',
    method: 'post',
    data
  })
}
/**
 * 编辑组织成员
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationMemberUpdate(data) {
  return request({
    type: 'base',
    url: 'organization/member/update',
    method: 'post',
    data
  })
}
/**
 * 根据组织名及登录人员信息，获取对应的组织列表（非树形）（WZP）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationOrgMemberConditionListGet(data) {
  return request({
    type: 'base',
    url: 'organization/org/member/condition/list/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织名及登录人员信息，获取对应的组织列表（树形）（WZP）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationOrgMemberConditionTreeListGet(data) {
  return request({
    type: 'base',
    url: 'organization/org/member/condition/tree/list/get',
    method: 'post',
    data
  })
}
/**
 * 树形体系和组织搜索功能
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationOrgMemberSelect(data) {
  return request({
    type: 'base',
    url: 'organization/org/member/select',
    method: 'post',
    data
  })
}
/**
 * 获取子组织列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationSonListGet(data) {
  return request({
    type: 'base',
    url: 'organization/son/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取子组织及本组织列表(内部，无参调用)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationSonselfInnerListGet(data) {
  return request({
    type: 'base',
    url: 'organization/sonself/inner/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取子组织及本组织列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationSonselfListGet(data) {
  return request({
    type: 'base',
    url: 'organization/sonself/list/get',
    method: 'post',
    data
  })
}
/**
 * 查询组织和部门的树形结构
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationSysTreeList(data) {
  return request({
    type: 'base',
    url: 'organization/sys/tree/list',
    method: 'post',
    data
  })
}
/**
 * 根据体系编号获取组织列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationSysidListGet(data) {
  return request({
    type: 'base',
    url: 'organization/sysid/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取组织上级组织列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationUpListGet(data) {
  return request({
    type: 'base',
    url: 'organization/up/list/get',
    method: 'post',
    data
  })
}
/**
 * 编辑组织信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function organizationUpdate(data) {
  return request({
    type: 'base',
    url: 'organization/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Organization.js